import React from 'react'
import { Container } from 'reactstrap'
import useResoulutionMatcher from '../../../hooks/useResolutionMatcher'

const AppContainer = ({ children, ...rest }) => {
  const isWindowBiggerThanMd = useResoulutionMatcher('md')

  return (
    <Container {...rest} fluid={!isWindowBiggerThanMd}>
      {children}
    </Container>
  )
}

export default AppContainer
